import React from 'react';
import { connect } from 'react-redux';
import { uploadIdPhoto, updateIdPhotoLocal, reenableIdPhotoUpload, fetchIdPhotoIfNeeded }
  from 'registration/creative/ducks';
import IdCapture from 'registration/creative/components/id_capture';

const mapStateToProps = ({
  creativeRegistration: {
    idPhoto, selfie, idUploaded, uploadingId, error, magicLinkSentFromMobile, fetching,
    idPhotoApproved, selfieApproved, idValidationRejectionNote
  }
}) => ({
  idPhoto,
  selfie,
  idUploaded,
  uploadingId,
  error,
  magicLinkSentFromMobile,
  fetching,
  idPhotoApproved,
  selfieApproved,
  idValidationRejectionNote
})

export default connect(mapStateToProps, {
  uploadIdPhoto,
  updateIdPhotoLocal,
  reenableIdPhotoUpload,
  fetchIdPhotoIfNeeded
})(IdCapture);



// WEBPACK FOOTER //
// ./registration/creative/containers/id_capture.jsx